import React, { useState, useEffect, useRef, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import Product from "../component/ProductComponent"
import { Chip, FormGroup, FormControlLabel, Checkbox, Box, CircularProgress } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useInfiniteLoad from '../component/useInfiniteLoad';
import _ from 'lodash';
import DOMPurify from 'dompurify';
import ClearIcon from '@mui/icons-material/Clear';
import CircleIcon from '@mui/icons-material/Circle';

//override accorion style
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: "0",
    borderRight: "0",
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));
//override accorion style
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon />}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(-180deg)',
    },
    '& .MuiAccordionSummary-expandIconWrapper svg': {
        fill: "#bab7ab", stroke: "#bab7ab", strokeWidth: "1px"
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
//override accorion style
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(1),
    borderTop: '0',
}));

function MainPage(props) {

    const collectionHandle = props.collectionHandle//stores current collection handle from liquid
    const collectionObj = JSON.parse(props.collectionObj)//stores current collectionObj from liquid
    const collectionLength = props.collectionLength

    const [expanded, setExpanded] = React.useState('panel1');//stores current accorion panel
    const [checkedFilters, setCheckedFilters] = useState([])//used to generate facet chips,contains only checked facets
    const [page, setPage] = useState(1)//stores current page nubmer
    //filters query generated from pseudoFilters below, and used in api request.
    const [filters, setFilters] = useState({
        "all": [
            {
                "collection_handles": [collectionHandle]
            }
        ]
    })
    //filters with field as a key, for easy data binding
    const pseudoFilters = useRef({
        "collection_handles": [collectionHandle]
    })

    //Return sanitized collection description
    const sanitizedData = () => ({
        __html: DOMPurify.sanitize(collectionObj.body_html || "<p></p>")
    })

    //resets page to 1, whenever filter query got changed
    useEffect(() => {
        setPage(1)
    }, [filters])

    //Response data from API call
    const { loader, facets, products, hasMore, setFacets } = useInfiniteLoad(filters, pseudoFilters.current, page, collectionHandle)
    //stores intersectionobserver reference
    const observer = useRef()
    //mapped to last product in the grid, for lazy binding the api data.
    const lastProductElementRef = useCallback(node => {
        if (loader) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            //Increments page when last product comes to view(entries[0].isIntersecting=>true) and last api call returns hasMore as => true
            if (entries[0].isIntersecting && hasMore) {
                setPage(prevPage => prevPage + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loader, hasMore])

    //handles facet click event, checkbox is hidden.
    const handleChecked = (e, isEvent) => {
        // console.log(e.target.name, e.target.value, e.target.checked, e.target.tabIndex)
        const { name: fieldname, value, checked, tabIndex } = isEvent === true ? e.target : e
        // console.log("checkbox", { fieldname, value, checked, tabIndex })
        //console.log(fieldname, value, checked, tabIndex)
        let newFacets = [...facets]
        let facet_index = newFacets.findIndex(f => f.facetname == fieldname)
        let oldFacet_index = newFacets[facet_index]["data"].findIndex(d => d?.checked == true)
        //console.log("oldFacet_index", oldFacet_index)

        if (oldFacet_index > -1) {
            newFacets[facet_index]["data"][oldFacet_index]["checked"] = false
        }

        newFacets[facet_index]["data"][tabIndex]["checked"] = checked

        setFacets(newFacets)

        let newCheckedFilters = [...checkedFilters]

        if (checked) {
            let index = newCheckedFilters.findIndex(f => f.fieldname == fieldname)
            // console.log(index, "<= index")
            if (index > -1) {
                newCheckedFilters[index] = { fieldname, value, checked, tabIndex }
            }
            else {
                newCheckedFilters.push({ fieldname, value, checked, tabIndex })
            }
            // if (pseudoFilters.current[fieldname]) {
            //     if (!pseudoFilters.current[fieldname].includes(value)) {
            //         pseudoFilters.current[fieldname].push(value)
            //     }
            // }
            // else {
            pseudoFilters.current[fieldname] = [value]
            // }
        }
        else {
            if (pseudoFilters.current[fieldname]) {
                //     const index = pseudoFilters.current[fieldname].indexOf(value);
                //     if (index > -1) {
                pseudoFilters.current[fieldname].splice(0, 1);
            }

            // }

            let index = newCheckedFilters.findIndex(f => f.value == value)
            //console.log("else", index)
            newCheckedFilters.splice(index, 1)
        }
        setCheckedFilters(newCheckedFilters)
        setFilters(generateFilterQuery())
        // console.log("newchecked =>", newCheckedFilters)
        // console.log("pseudoFilters =>", pseudoFilters.current)
        //console.log("generateFilterQuery =>", generateFilterQuery())
        // console.log("newFacets =>", newFacets)

        //+ getFacet(filters.current)
    }

    //Generates facet filter query for api call
    const generateFilterQuery = () => {
        let filterQuery = []

        Object.keys(pseudoFilters.current).forEach((key) => {
            if (pseudoFilters.current[key].length > 0) {
                let newObj = {}
                newObj[`${key}`] = pseudoFilters.current[key]
                filterQuery.push(newObj)
            }
        });

        return { "all": filterQuery }
    }
    //handle facet chip element remove action
    const handleDelete = (data) => {
        data['name'] = data['fieldname']
        data['checked'] = false
        handleChecked(data, false)
    }
    //Generates readmore content for Collection description
    const ReadMore = ({ data, className }) => {
        //console.log(data.__html)
        const text = data.__html;
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };
        return (
            <div className={className} onClick={toggleReadMore}>
                {isReadMore ? <div dangerouslySetInnerHTML={{ __html: text.substr(0, 360) }}></div> : <div dangerouslySetInnerHTML={{ __html: text }}></div>}
                <span className="read-or-hide">
                    {isReadMore ? "...Read More" : " Show Less"}
                </span>
            </div>
        );
    };
    //handles facet Accordion toggle
    const handleAccordionToggle = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const [mobileAccordion, setMobileAccordion] = useState(false)

    return (
        <div>
            <div className='custom-filter-container'>
                <div className={`custom-filter_left-panel ${collectionLength == 0 ? "no-collection" : ""}`}>
                    <div className={`facet-list_flex-container ${mobileAccordion ? "mobile_open" : ""}`}>
                        <Accordion
                            key={`filters_accordion_wrapper_mobile`}
                            className={`facet-items-container_mobile`}
                            onChange={() => { setMobileAccordion(!mobileAccordion); mobileAccordion == true && setExpanded(false) }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="filters_accordion_mobile"
                                id="filters_accordion_mobile"
                            >
                                <h3 className='facet-title' >Add Filters</h3>
                            </AccordionSummary>
                        </Accordion>
                        {checkedFilters && checkedFilters.map((checkbox, index) => {
                            return <Chip
                                key={`filterchip_${index}`}
                                label={checkbox.value}
                                onDelete={() => { handleDelete(checkbox) }}
                                deleteIcon={<ClearIcon sx={{ fill: "#fff", stroke: "#fff", strokeWidth: "2px" }} />}
                            />
                        })
                        }
                        {facets?.length > 0 ? facets.map((facet, index) => {
                            if (facet.data?.length > 0) {
                                return (
                                    <Accordion
                                        expanded={expanded === `panel_${index}`}
                                        onChange={handleAccordionToggle(`panel_${index}`)}
                                        key={`${facet.facetname}__`}
                                        className={`facet-items-container ${index === facets.length - 1 && index % 2 == 0 ? "last_item" : ""}`}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={facet.facetname}
                                            id={facet.facetname}
                                        >
                                            <h3 className='facet-title' >{facet.name.replace("_", " ")}</h3>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <FormGroup className='facet-checkbox-list'>
                                                {
                                                    facet.data.map((obj, i) => {
                                                        // Skip rendering if obj.value is "Marcus William Fabrics"
                                                        if (obj.value === "Marcus William Fabrics" || obj.value  === "Bassett Mcnab Fabrics") return null;

                                                        return (
                                                            <React.Fragment key={`checkbox_${facet.facetname}_${i}`}>
                                                                <FormControlLabel
                                                                    className='facet-checkbox'
                                                                    control={
                                                                        <Checkbox
                                                                            name={facet.facetname}
                                                                            type="checkbox"
                                                                            onChange={(e) => {
                                                                                handleChecked(e, true);
                                                                            }}
                                                                            tabIndex={i}
                                                                            value={obj.value}
                                                                            checked={obj.checked === true}
                                                                        />
                                                                    }
                                                                    label={(() => {
                                                                        if (facet.facetname?.toLowerCase() === "menu_color") {
                                                                            let valueArr = [];

                                                                            if (obj.value.includes("/")) {
                                                                                valueArr = obj.value.split("/");
                                                                            } else if (obj.value.includes("|")) {
                                                                                valueArr = obj.value.split("|");
                                                                            } else {
                                                                                valueArr = obj.value.split(" ");
                                                                            }

                                                                            return (
                                                                                <span className='checkbox_color_icon'>
                                                                                    <CircleIcon
                                                                                        sx={{
                                                                                            fill: `${valueArr[0]}`,
                                                                                            marginRight: "5px",
                                                                                            fontSize: "20px",
                                                                                        }}
                                                                                    />
                                                                                    <span className='facet-checkbox-text'>
                                                                                        {`${obj.value} (${obj.count || 0})`}
                                                                                    </span>
                                                                                </span>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <span className='facet-checkbox-text'>
                                                                                {`${obj.value} (${obj.count || 0})`}
                                                                            </span>
                                                                        );
                                                                    })()}
                                                                />
                                                            </React.Fragment>
                                                        );
                                                    })
                                                }

                                                {facet.facetname === "brand" && facet.data?.length === 1 && (
                                                    <div className='view-all-brand'>
                                                        <a href={
                                                            collectionHandle.toLowerCase().includes("fabrics")
                                                                ? "/collections/designer-fabrics"
                                                                : "/collections/designer-wallpaper"
                                                        }>
                                                            View All Our {collectionHandle.toLowerCase().includes("fabrics") ? "Fabrics" : "Wallcoverings"}
                                                        </a>
                                                    </div>
                                                )}
                                            </FormGroup>

                                        </AccordionDetails>
                                    </Accordion>
                                );
                            }
                        }) : <Box sx={{ display: 'flex', justifyContent: "center" }}>
                            <CircularProgress />
                        </Box>}
                        <div className="show-for-medium">
                            <div className="price-quote-form ">
                                <h3 className="title"><strong style={{ fontSize: "18px", color: "black" }}>Looking for a Designer Fabric, Wallpaper, Trim or Home Accessory Item that we do not Show on Our Site?</strong></h3>
                                <button className="btn primary-btn open-overlay" data-overlay="quote-form" >Request A Price</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="show-for-mobile">
                    <div className="price-quote-form ">
                        <h3 className="title"><strong style={{ fontSize: "18px", color: "black" }}>Looking for a Designer Fabric, Wallpaper, Trim or Home Accessory Item that we do not Show on Our Site?</strong></h3>
                        <button className="btn primary-btn open-overlay" data-overlay="quote-form" >Request A Price</button>
                    </div>
                </div>
                <div className={`custom-filter_right-panel ${collectionLength == 0 ? "no-collection" : ""}`}>
                    <ReadMore className='collection-details_container' data={sanitizedData()}>
                    </ReadMore>
                    <div className='product-grid_flex-container'>
                        {products.length > 0 && products.map((prod, index) => {
                            if (prod.p_status?.raw?.toLowerCase() === "draft") return null;
                        
                            if (products.length === index + 1) {
                                return <Product
                                    lastProductElementRef={lastProductElementRef}
                                    key={`product_block_${index}`}
                                    title={prod.p_title.raw}
                                    image={prod.p_image_src.raw}
                                    price={`${prod.price.raw}${collectionHandle.toLowerCase().includes("fabrics") ? "/yard" : "/roll"}`}
                                    showAddToCart={false}
                                    PDPUrl={`${location.origin}/products/${prod.p_handle.raw}`}
                                ></Product>
                            }
                            else {
                                return <Product
                                    key={`product_block_${index}`}
                                    title={prod.p_title.raw}
                                    image={prod.p_image_src.raw}
                                    price={`${prod.price.raw}${collectionHandle.toLowerCase().includes("fabrics") ? "/yard" : "/roll"}`}
                                    showAddToCart={false}
                                    PDPUrl={`${location.origin}/products/${prod.p_handle.raw}`}
                                ></Product>
                            }
                        })}
                    </div>
                    {loader && collectionLength > 0 ? <Box sx={{ display: 'flex', justifyContent: "center" }}>
                        <CircularProgress />
                    </Box> : products.length == 0 && collectionLength > 0 && <div className='no_product'>No products found...!</div>}
                </div>
            </div>
        </div>)
}


export default MainPage;